import { FC } from "react";

import { Workspace } from "@/domain/workspace/models/workspace-model";

import { ClimateAction } from "../../models/climate-action";

import { ProgressSnapshotEventList } from "./progress-snapshot-event-list";

interface ClimateActionEventFeedProps {
  workspace: Workspace;
  climateAction: ClimateAction;
}

export const ClimateActionEventFeed: FC<ClimateActionEventFeedProps> = ({ climateAction, ...props }) => {
  return (
    <div className="relative flex flex-col items-start overflow-hidden pt-6">
      <ProgressSnapshotEventList {...props} climateAction={climateAction} />
    </div>
  );
};
